/**
 * MyCommunications form
 */
app.modal.mycomms = (function() {
    "use strict";
    var formData = {},
        cookieName = 'myyl_comms',
        cookieData = {},
        self = {

        init: function() {
            // only for skava enabled regions
            if (!app.main.getSettings().mycomms_enabled) {
                return;
            }

            var cookie = app.cookie.get(cookieName);

            if (cookie) {
                cookieData = JSON.parse(cookie);
            }

            if (cookieData.submitted || cookieData.viewed) {
                // submitted previously, never audo-show again
                return;

            } else {
                // auto open
                self.open();
            }
        },

        open: function() {
            app.modal.init();
            app.modal.setCloseCallback(self.close);
            app.page.load('json/'+ app.main.getCurrentCulture() +'/page-mycomms.json', self);
        },

        close: function() {
            if (cookieData.submitted) {
                // leave existing data
                return;
            }

            cookieData.viewed = true;
            // expires in 7 days
            app.cookie.set(JSON.stringify(cookieData), cookieName, 168);
        },

        render: function(data) {
            // handle a lang key that needs string insertion
            data.p1 = app.main.strReplace(data.p1, app.main.getProfile().display_name);

            app.main.getTemplate('modal-mycomms', {}, true, function() {
                app.modal.load('modal-mycomms', data);
                self.postRender();
            });
        },

        postRender: function() {
            $('.required').on('blur', function(e) {
                var name = e.currentTarget.id.split('-')[2];

                if (!$(this).val()) {
                    $(this).addClass('error');
                    $('.field-error.'+ name).text(app.main.lang('error_required_field')).show();

                } else {
                    $(this).removeClass('error');
                    $('.field-error.'+ name).empty().hide();
                }
            });

            $('#field-mycomms-phone').on('blur', function(e) {
                if ($(this).val()) {
                    if (!app.pws.validatePhone($(this).val())) {
                        $(this).addClass('error');
                        $('.field-error.phone').text(app.main.lang('error_phone_invalid')).show();

                    } else {
                        $(this).removeClass('error');
                        $('.field-error.phone').empty().hide();
                    }

                } else {
                    $(this).removeClass('error');
                    $('.field-error.phone').empty().hide();
                }
            });
        },

        validateForm: function() {
            var isValid = true,
                currentField = $('#field-mycomms-email');

            $('#modal-form .required').each(function() {
                var name = $(this).attr('id').split('-')[2];

                if (!$(this).val()) {
                    $(this).addClass('error');
                    $('.field-error.'+ name).text(app.main.lang('error_required_field')).show();
                    isValid = false;

                } else {
                    $(this).removeClass('error');
                    $('.field-error.'+ name).empty().hide();
                }
            });

            if (app.pws.validateEmail(currentField.val())) {
                $('.field-error.email').empty().hide();
                currentField.removeClass('error');

            } else {
                $('.field-error.email').text(app.main.lang('error_email_invalid')).show();
                currentField.addClass('error');
                isValid = false;
            }

            currentField = $('#field-mycomms-phone');

            if (currentField.val()) {
                if (app.pws.validatePhone(currentField.val())) {
                    $('.field-error.phone').empty().hide();
                    currentField.removeClass('error');

                } else {
                    $('.field-error.phone').text(app.main.lang('error_phone_invalid')).show();
                    currentField.addClass('error');
                    isValid = false;
                }
            }

            return isValid;
        },
 
        submitForm: function(token) {
            // add response token to formData
            formData.recaptcha_token = token;
            console.log('recaptcha token: '+ token);

            if (self.validateForm()) {
                var date = new Date();
                formData.date = date.toISOString();

                formData.first_name = $('#field-mycomms-firstname').val();
                formData.last_name = $('#field-mycomms-lastname').val();
                formData.email = $('#field-mycomms-email').val();
                formData.phone = $('#field-mycomms-phone').val();

                app.page.showLoader();

                console.log('sending formData', formData);

                app.skava.sendRequest({
                    useAPI: true,
                    url: 'v2/en-us/prospects/'+ app.main.getProfile().member_id +'/',
                    method: 'POST',
                    data: JSON.stringify(formData)

                }, function(res) {
                    app.page.hideLoader();

                    delete cookieData.viewed;
                    cookieData.submitted = true;
                    // max expiration allowed is 400 days
                    app.cookie.set(JSON.stringify(cookieData), cookieName, 9600);

                    app.modal.close();

                }, function(err) {
                    app.page.hideLoader();
                });

            } else {
                // form is invalid
            }
        }
    };

    return self;
}());
